// extracted by mini-css-extract-plugin
export default {"root":"styles_root__f+G0Z","container":"styles_container__dtwdW"};